import { API } from '../constants';

const TYPE_JSON = 'application/json';
const CONTENT_TYPE = 'Content-Type';

const OPTIONS = {
	headers: { [CONTENT_TYPE]: TYPE_JSON },
	method: 'POST',
};

const isJson = (response) => response.headers.get(CONTENT_TYPE).includes(TYPE_JSON);

const api = async ({ data, path = '' }) => {
	try {
		const response = await fetch(`${API.basePath}${path}`, {
			body: JSON.stringify(data),
			...OPTIONS,
		});
		const success = response.ok;
		if (isJson(response)) {
			const json = await response.json();
			return { json, success };
		} else if (success) {
			return { success };
		} else {
			throw Error(response.statusText);
		}
	} catch (error) {
		throw Error(error);
	}
};

// See http://docs.taggis.com/
export const contactRequest = (data) => api({ data, path: 'contact' });
export const registerUser = (data) => api({ data: { user: data }, path: 'users' });
export const resetUserPassword = (data) => api({ data, path: 'users/reset_password' });
export const signInUser = (data) => api({ data, path: 'login' });
export const updateUserPassword = (data) => api({ data, path: 'users/update_password' });



// WEBPACK FOOTER //
// ./src/services/taggisApi.js